import { useState,useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";
import { ReactComponent as MinusSign } from "../../assets/svg/minus-sign.svg";
import { ReactComponent as PlusSign } from "../../assets/svg/add-circle.svg";
import { Container, Row, Col } from "react-bootstrap";
import "../visitor/visitor-create/visitor-create.css";
import SearchWithFreeTextAPI from "../common/searchbox/searchbox-free-text.js";

 const AddItemModal = ({moduleName,itemData, onSave,onCancel }) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const modalStyle = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        },
        modal: {
          backgroundColor: "#ffffff",
          
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "718px",
          height:"378px",
          overflowY: "auto",
        },
      };


 const [loading, setLoading] = useState(false);
  const [itemName, setItemName] = useState("");
  const [quantity, setQuantity] = useState(1);
    const [description, setDescription] = useState("");
    useEffect(() => {
      if(itemData!=null){
      setItemName(itemData.item.item_name);
      setQuantity(itemData.item.quantity)
      setDescription(itemData.item.description)
      }
     },[itemData]);   
   
    
    const [validations, setValidations] = useState({
      name: "",
      description: "",
          });
      const handleItemDropdownChange = (option) => {
    console.log(option)
    setItemName(option.value)
  };
  const handleItemOnChange = (term) => {  
    setItemName(term)       
  };     
         
    return ( <div style={modalStyle.overlay}>
        <div style={modalStyle.modal}>
          <div style={{ color: "#ffffff" }}>
            <div className="modal-header style-justify-between"
            >
              <div className="add-item-modal-title"
    >
    Add Item 
    </div>
      <ModalCloseIcon
                style={{ cursor: "pointer" }}
                onClick={onCancel}
              />
            </div>

            <div style={{padding: "16px 24px", }}>
            <Row>
              <Col xs={12} sm={12} md={9} >
                <div className="field-title">
                      Item Name<span style={{color:'#FF4444'}}>*</span>
                    </div>
                     <SearchWithFreeTextAPI  onDropdownChange={handleItemDropdownChange} onChangeSearch={handleItemOnChange} apiUrl={apiUrl+`get_items`} params={{type:moduleName.toLowerCase()}} searchLimit={0} placeholder={"Item"} selectedValue={itemName}/> 
                 {/*  <input
                    type="text"
                    placeholder=" "
                    className="input-field mt-2 w-100"
                    value={itemName}
                    onChange={(event) => {
                      setItemName(event.target.value.trim()); // Update state with input value
                    }}
                  /> */}
                  <span className="field-error" >{validations.name}</span>
                  </Col>
                  <Col xs={12} sm={12} md={3}>
                <div className="field-title">
                      Quantity
                    </div>
                  <div className="style-justify-start mt-2">
                    <MinusSign style={{cursor:'pointer'}} onClick={()=>{ quantity>1 && setQuantity(quantity-1)}}/>
                    <div className="item-quantity">
                      {quantity}
                    </div>
                    <PlusSign style={{cursor:'pointer'}} onClick={()=>{ setQuantity(quantity+1)}}/>
                  </div>
                 {/*  <span className="field-error" >{validations.description}</span> */}
                  </Col>
                </Row>
            <Row>
            <Col xs={12} style={{paddingTop:'12px',}}>
                                                  <div className="field-title mb-1">Description</div> 
                                                  <div>
                        <textarea
                          type="text"
                          placeholder=" "
                          className="input-field w-100"
                          value={description}
                          onChange={(event) => {
                            setDescription(event.target.value.trim()); // Update state with input value
                          }}
                        />
                         <span className="field-error">{validations.description}</span>
                      </div>
                      </Col>
                 
              </Row>
                            
               
              
           
              
             
              <Row className="mt-3"                
              >
                <div className="style-justify-end">
                <div
                  onClick={onCancel} className="cancel-modal-btn style-justify-center"                  
                >
                 Cancel
                </div>
                <div className="save-modal-btn style-justify-center"
                  onClick={ (e) => {
                    if(itemName===""){
                     setValidations({
                        name: "Item name required",
                        description: "",
                            });
                    }else{
                     onSave({'item':{'item_name':itemName, 'quantity':quantity, 'description':description},'index':itemData?.index??null}) 
                    }
                  }}>
                  Save
                </div>
                </div>
              </Row>
            </div>
          </div>
        </div>
      </div>);

}

export default AddItemModal;